// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export type {
  CommunicationTokenCredential,
  CommunicationGetTokenOptions,
} from "./communicationTokenCredential.js";
export { AzureCommunicationTokenCredential } from "./azureCommunicationTokenCredential.js";
export type { CommunicationTokenRefreshOptions } from "./autoRefreshTokenCredential.js";
export type { EntraCommunicationTokenCredentialOptions } from "./entraTokenCredential.js";
export * from "./credential/index.js";
export * from "./identifierModels.js";
export * from "./identifierModelSerializer.js";
export { RestError, isRestError } from "@azure/core-rest-pipeline";
